import { render } from "./CardFormSan.vue?vue&type=template&id=7877e0ba"
import script from "./CardFormSan.vue?vue&type=script&lang=js"
export * from "./CardFormSan.vue?vue&type=script&lang=js"

import "./CardFormSan.vue?vue&type=style&index=0&id=7877e0ba&lang=css"

import exportComponent from "D:\\fclinique\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__